import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "onClick", "className", "style", "disabled", "isLoading", "theme"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Theme } from '@guestyci/foundation/enums/enums';
import BaseButton from "../BaseButton/BaseButton";
var lightThemeClasses = 'text-white text-hover-blue-dark-theme';

var FlatButton = function FlatButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      style = _ref.style,
      disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BaseButton, _extends({
    isLoading: isLoading,
    loaderColor: "blue",
    onClick: onClick,
    className: cn('font-size-md', className, _defineProperty({}, lightThemeClasses, theme === Theme.Light)),
    variant: "flat",
    style: style,
    disabled: disabled
  }, props, {
    "data-qa": "flat-button"
  }), children);
};

FlatButton.defaultProps = {
  className: '',
  style: {},
  disabled: false,
  isLoading: false,
  theme: 'dark'
};
FlatButton.propTypes = {
  /** Button click callback function */
  onClick: PropTypes.func.isRequired,

  /** Button inner children */
  children: PropTypes.node.isRequired,

  /** Button indicator whether disabled or not */
  disabled: PropTypes.bool,

  /** Button additional classes */
  className: PropTypes.string,

  /** Button additional styling */
  style: PropTypes.shape(),

  /** Button additional styling */
  isLoading: PropTypes.bool,

  /** Defined the theme for the button component */
  theme: PropTypes.oneOf(['dark', 'light'])
};
export default FlatButton;